export class navigationClose {
	constructor( node ) {
		this.node = node;
		if ( ! this.node ) {
			return;
		}

		this.node.addEventListener( 'click', ( e ) => {
			if ( this.node.ariaExpanded === 'true' ) {
				e.target.ariaExpanded = 'false';
			} else {
				e.target.ariaExpanded = 'true';
			}
		} );
	}
}
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.wp-block-navigation-submenu__toggle' ).forEach( ( node ) => {
		new navigationClose( node );
	} );
} );
